import React, { Component } from 'react';
import '../styles/App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom'; //Switch
import Baselayout from '../components/Baselayout';
import Home from '../components/Home';
import About from '../components/About';
import TermsOfUse from '../components/terms';
import Top_Sellers from '../components/top_sellers';
import PrivacyPolicy from '../components/privacy';
import OptInForm from '../components/opt-in-form';
import Login from '../components/login';
import Register from '../components/register';
import MyAccount from '../components/myaccount';
import Checkout from '../components/checkout';
import Checkout1 from '../components/checkout1';
import Checkout2 from '../components/checkout2';
import Checkout3 from '../components/checkout3';
import Tariff_faq from '../components/tariff_faq';
import Product from '../components/product';
import ContactUs from '../components/contact_us';
import ViewCart from '../components/viewcart';
import Category from '../components/category';
import Search from '../components/search';
import Account from '../components/accountedit';
import Forgot from '../components/forgot';
import Reset from '../components/reset';
import Orders from '../components/orders';
import ViewOrder from '../components/vieworder';
import ProductList from '../components/product-list';
import PdfRedirect from '../components/pdf_redirect';
import Spinner from '../components/spinner';
import * as Utilities from './utilities.js';


// import logo from '../msair100.jpg';
// import movement from '../movement.jpg';
//import './App.css';
// import axios from 'axios';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
	  topNav: null,
	  //itemsInCart: null,
    };
  }
  

  componentDidMount() {

        //Redirect user to PDF page if possible
	    var p = window.location.href;
	    var files = p.indexOf("files") +6;
	    var pdf = p.indexOf("pdf") -1;
	    var stop = p.length;
	    if(pdf > 0 & files > 0) {
	        var pdf_number = p.substring(files, pdf);
	        if(pdf_number > 0)
	            window.location = 'https://www.msaironline.com/pdf_redirect?file='+pdf_number+'.pdf';
	            //alert(files+" | "+stop+" | "+pdf+" | "+pdf_number); 
	    }
	    
  
  
	var topNav = null;
	var headMessage = null;
  	var url = Utilities.getApiURL('session.php', '');
    fetch(url, {method: 'GET', credentials: 'include'})
    .then(results => {
      return results.json();
    }).then((data) => {
    
        if(data.is_logged_in === true){
			topNav = (<div id="top-links">
			  <a className="active" href="/myaccount">Hello, {data.user}. &nbsp; My Account</a>
              <a href="/login?do=logout">Logout</a>
            </div>)
			this.setState({topNav: topNav});
		} else {
			topNav = (
			 <div id="top-links">
              <a href="/register">Register</a>
              <a href="/login">Login</a>
            </div>)
			this.setState({topNav: topNav});
		}
		
		if(data.message) {
		   headMessage = (
			 <div>{data.message} </div>
			 )
			this.setState({headMessage: data.message});
		}
		
		//attempt to keep session alive for admins
		/*if(data.admin === true){
            const timerId = setTimeout(() => {
                fetch(url, {method: 'GET', credentials: 'include'})
                    .then(results => {
                })
            }, 2000);
		}*/
		//if(data.items_in_cart > 0){
		//	this.setState({itemsInCart: data.items_in_cart});
		//}
    })

  }

  render() {
    return (

      <div className="App">
        <div className="header">

        <div className="top-header">

          <div className="header header-v1">
            <div className="header-language-background">
              <div className="wrap-container">
                <div className="header-wrap">
                  <div id="welcome-msg">
                    <strong>CALL NOW: 1-877-MSAIR99</strong>
                      {/* <i className="fas fa-phone-square fa-1x"></i> */}


                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="top-nav">
			{this.state.topNav}
          </div>
        </div>


        <div className="middle-header">

          <div className="title-wrapper">
            <div className="title-header">
              <div className="app-header">
                {/* <img src={movement} alt="movement" /> */}
                <div className="content">
                <div className="title-header-left-div">
                    <div id="app-title">MS <font color="yellow">AIR</font></div>
                    <div id="headerSlogan" className="headerSlogan">
                        <p>Your source for compressed air & vacuum components for medical, dental, laboratory and industrial applications.</p></div>
                    <div id="headerMessage" className="headerMessage"><p>{this.state.headMessage}</p></div>
                </div>

                  <div className="title-header-right-div">
                    <div className="social-wrapper right-div">
                      {/* <nav id="social-nav">
                        <div className="social-header">
                          <h6>Connect With Us:</h6>
                        </div>
                        <div className="social-icons">
                          <a href="https://www.facebook.com" rel="noopener noreferrer" target="_blank">
                          <i className="fab fa-facebook-square fa-2x"></i></a>
                          <a href="https://www.twitter.com"  rel="noopener noreferrer" target="_blank">
                          <i className="fab fa-twitter-square fa-2x"></i></a>
                          <a href="https://www.linkedin.com/company/ms-air/" rel="noopener noreferrer" target="_blank">
                          <i className="fab fa-linkedin fa-2x"></i></a>
                          <a href="mailto:msaironline@msaironline.com" rel="noopener noreferrer" target="_blank">
                          <i className="fas fa-envelope fa-2x"></i></a>
                        </div>
                      </nav> */}


                    <div className="checkout-wrapper">
                      <div className="checkout">
                        <a href="/viewcart" className="btn btn-info btn-lg">
                          {/* <span className="glyphicon glyphicon-shopping-cart"></span> */}
                            <p>Shopping Cart</p>
                              <i className="fas fa-shopping-cart fa-2x"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>




                </div>

          </div>
        </div>
      </div>

    </div>
</div>
          <div className="bottom-header">
            <a className="active" href="/">Home</a>
            <a href="/viewcart">View Cart <i className="fas fa-shopping-cart"></i></a>
            <a href="/about">About Us</a>
            <a href="/contact_us">Contact Us</a>
            <a href="/tariff_faq">Tariff FAQ</a>

            <div className="search-container">
              <form action="/search">
                <input className='searchText' type="text" placeholder="Search.." name="phrase"></input>
                <button type="submit" ><i className="fa fa-search"></i></button>
              </form>
            </div>
          </div>


          {/* <div className="App">
            ...
            <CategoryList categories={this.state.categories} />
          </div> */}




      <BrowserRouter>
        <Baselayout>
          <Routes>
            <Route path ="/" element={<Home />}/>
            <Route path ="/about" element={<About />}/>
            <Route path="/terms" element={<TermsOfUse />}/>
            <Route path="/top_sellers" element={<Top_Sellers />}/>
            <Route path="/privacy" element={<PrivacyPolicy />}/>
            <Route path="/opt-in-form" element={<OptInForm />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/register" element={<Register />}/>
            <Route path="/myaccount" element={<MyAccount />}/>
            <Route path="/checkout" element={<Checkout />}/>
            <Route path="/checkout1" element={<Checkout1 />}/>
            <Route path="/checkout2" element={<Checkout2 />}/>
            <Route path="/checkout3" element={<Checkout3 />}/>
            <Route path="/product" element={<Product />}/>
            <Route path="/contact_us" element={<ContactUs />}/>
            <Route path="/tariff_faq" element={<Tariff_faq />}/>
            <Route path="/viewcart" element={<ViewCart />}/>
            <Route path="/category" element={<Category />}/>
	          <Route path="/search" element={<Search />}/>
	          <Route path="/accountedit" element={<Account />}/>
	          <Route path="/forgot" element={<Forgot />}/>
	          <Route path="/reset" element={<Reset />}/>
	          <Route path="/orders" element={<Orders />}/>
	          <Route path="/vieworder" element={<ViewOrder />}/>
	          <Route path="/product-list" element={<ProductList />}/>
	          <Route path="/pdf_redirect" element={<PdfRedirect />}/>
	          <Route path="/search" element={<Search />}/>
            <Route path="/spinner" element={<Spinner />}/>
            //<Route path="/files/*" element={<PdfRedirect />} />
          </Routes>
        </Baselayout>
      </BrowserRouter>
      </div>
    );
  }
}

export default App;
